// Single source of truth for status -> label/colour across the Batch Transfer feature (FR-12.1)
// ค่าสีทั้งหมดถอดมาจาก design ตัวจริง (Batch CSV Upload.dc.html) — ห้าม hardcode ซ้ำที่อื่น
// withdrawNoteStatus ใช้ 'canceled' (L เดียว) ให้ตรงกับ WithdrawNoteEnum ฝั่ง backend

const UPLOAD_STATUS = {
  success: { label: 'Upload success', bg: '#E4F3EA', fg: '#25764F' },
  failed: { label: 'Upload failed', bg: '#FCE6E4', fg: '#C0392B' }
}

const WITHDRAW_NOTE_STATUS = {
  none: { label: '—', bg: 'transparent', fg: '#B4BBC4' },
  pending: { label: 'Pending', bg: '#FDF1DC', fg: '#9A6712' },
  // Withdraw Note ในไฟล์ถูก approve ไปบางใบ ที่เหลือยัง pending
  partial_completed: { label: 'Partial Complete', bg: '#E4F3EA', fg: '#25764F' },
  completed: { label: 'Completed', bg: '#E1EEF7', fg: '#1B6E96' },
  canceled: { label: 'Canceled', bg: '#F2F4F6', fg: '#6B7280' }
}

// สถานะ Withdraw Note รายใบ (จาก WithdrawNote.status) แสดงต่อท้ายรหัสเป็น `WN001 ( pending )`
const ROW_WITHDRAW_NOTE_STATUS = {
  pending: '#9A6712',
  approved: '#25764F',
  canceled: '#C0392B'
}

// พื้นหลัง + แถบซ้ายของแถว ไล่ตามลำดับที่ Withdraw Note ปรากฏในกลุ่ม (FR-5.17)
export const WITHDRAW_NOTE_TINTS = [
  { bg: '#FFFBEB', bar: '#E8B84D' },
  { bg: '#FEF6EC', bar: '#E08B3E' },
  { bg: '#F1F7FD', bar: '#5C9AD6' },
  { bg: '#F5F2FC', bar: '#8B7BD1' },
  { bg: '#EFF8F3', bar: '#3E9E72' },
  { bg: '#FDF1F6', bar: '#C2679C' }
]

export const ROW_ERROR_BG = '#FDF3F2'

export const UPLOAD_STATUS_TABS = [
  { value: '', label: 'All' },
  { value: 'success', label: 'Upload success' },
  { value: 'failed', label: 'Upload failed' }
]

export function uploadStatusLabel (status) {
  return (UPLOAD_STATUS[status] && UPLOAD_STATUS[status].label) || status || '-'
}

export function uploadChipStyle (status) {
  const s = UPLOAD_STATUS[status]
  if (!s) return {}
  return { background: s.bg, color: s.fg }
}

export function withdrawNoteStatusLabel (status) {
  const s = WITHDRAW_NOTE_STATUS[status] || WITHDRAW_NOTE_STATUS.none
  return s.label
}

export function isWithdrawNoteStatusPlain (status) {
  return !status || status === 'none'
}

export function withdrawNoteChipStyle (status) {
  const s = WITHDRAW_NOTE_STATUS[status] || WITHDRAW_NOTE_STATUS.none
  if (isWithdrawNoteStatusPlain(status)) return { color: s.fg }
  return { background: s.bg, color: s.fg }
}

export function rowWithdrawNoteStatusLabel (status) {
  return ROW_WITHDRAW_NOTE_STATUS[status] ? `( ${status} )` : ''
}

export function rowWithdrawNoteStatusColor (status) {
  return ROW_WITHDRAW_NOTE_STATUS[status] || ROW_WITHDRAW_NOTE_STATUS.pending
}

// แถวหนึ่งแถวได้ tint จากลำดับของ Withdraw Note ที่มันสังกัด — index ส่งมาจากผู้เรียก
export function rowTintStyle (index) {
  const tint = WITHDRAW_NOTE_TINTS[index % WITHDRAW_NOTE_TINTS.length]
  return { background: tint.bg, boxShadow: `inset 3px 0 0 ${tint.bar}` }
}
